module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-checkbox-group"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4ae7802b","transformToRequire":{"audio":"src"}}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./~/_vue-easytable@1.7.2@vue-easytable/libs/v-checkbox-group/src/checkbox-group.vue
// module id = 932
// module chunks = 116